/** A feltöltött képet legfeljebb 480 px-es WebP-re kicsinyíti (a tároló limitje 512 KB). */
export async function fotoKicsinyites(fajl: File, max = 480): Promise<Blob> {
  const kep = await createImageBitmap(fajl);
  const arany = Math.min(1, max / Math.max(kep.width, kep.height));
  const vaszon = new OffscreenCanvas(Math.round(kep.width * arany), Math.round(kep.height * arany));
  const ctx = vaszon.getContext('2d');
  if (!ctx) throw new Error('A böngésző nem tudja feldolgozni a képet.');
  ctx.drawImage(kep, 0, 0, vaszon.width, vaszon.height);
  return vaszon.convertToBlob({ type: 'image/webp', quality: 0.85 });
}
